import { Brand, LogoAt, Page, Text } from "../primitives";
/** Reference page 3. Fixed — numbering and titles exactly as in the reference. */
const COLUMN_1 = [
    { num: ".01", title: "من نحن", numTop: 385, titleTop: 379 },
    { num: ".02", title: "الرؤيا و الرسالة", numTop: 449, titleTop: 442 },
    { num: ".03", title: "ما الذي نقدمه", numTop: 512, titleTop: 506 },
    { num: ".04", title: "الية العمل", numTop: 576, titleTop: 570 },
    { num: ".05", title: "المشروع", numTop: 639, titleTop: 633 },
    { num: ".06", title: "ترتيب اللوحات المقترح", numTop: 702, titleTop: 696 },
];
const COLUMN_2 = [
    { num: ".07", title: "اللوحات المقترحة", numTop: 385, titleTop: 385 },
    { num: ".08", title: "عرض السعر", numTop: 449, titleTop: 449 },
    { num: ".09", title: "تواصل معنا", numTop: 512, titleTop: 512 },
];
export function TableOfContentsPage() {
    return (<Page>
      <LogoAt cx={68.3} cy={92.6} w={31.9}/>
      <Brand right={1083} top={63} size={34}/>
      <Text right={1078} top={266} size={43} weight={700}>
        جدول المحتويات
      </Text>

      {COLUMN_1.map((row) => (<div key={row.num}>
          <Text left={1047} top={row.numTop} size={27} weight={500} dir="ltr">
            {row.num}
          </Text>
          <Text right={1043} top={row.titleTop} size={27} weight={300}>
            {row.title}
          </Text>
        </div>))}
      {COLUMN_2.map((row) => (<div key={row.num}>
          <Text left={737} top={row.numTop} size={27} weight={500} dir="ltr">
            {row.num}
          </Text>
          <Text right={731} top={row.titleTop} size={27} weight={300}>
            {row.title}
          </Text>
        </div>))}
    </Page>);
}
